import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label ,Table } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { CircularProgress } from "@material-ui/core";
import { AvForm } from "availity-reactstrap-validation";
import moment from "moment";
import Select from "react-select";
import ReactQuill from "react-quill";

const EditCampaignDgc = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];
  const campaignTypeOptions = [
    { value: "upsize", label: "Upsize" },
    { value: "discount", label: "Discount" },
    { value: "gwp", label : "GWP"}
  ];
  const [ID, setID] = useState("");
  const [campaignID, setCampaignId] = useState("");
  const [noOfUseTime, setNoOfUseTime] = useState();
  const [noLimit, setNoLimit] = useState(false);
  const [couponTitle, setCouponTitle] = useState("");
  const [couponDescription, setCouponDescription] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [dgcAmount,setDgcAmount]=useState()
  const [forMe, setForMe] = useState(false);
  const [forFreind, setForFriend] = useState(false);
  const [campaignType, setCampaignType] = useState();
  const [grabPay, setGrabPay] = useState(false);
  const [ocbc, setOcbc] = useState(false);
  const [creditCard, setCreditCard] = useState(false);
  const [payNow, setPayNow] = useState(false);
  const [lifeSGPaymentMethod, setLifeSGPaymentMethod] = useState(false);
  const [shopeePay, setShopeePay] = useState(false);
  const [sPayLater, setSPayLater] = useState(false);
  const [showPopUpMsg, setShowPopUpMsg] = useState(false);
  const [modalMessage, setModaleMessage] = useState("");
  const [percent, setPercenet] = useState();
  const [amount, setAmount] = useState();
  const [publishDate, setPublishDate] = useState("");
  const [unPublishDate, setUnPublishDate] = useState("");
  const [neverEnding, setNeverEnding] = useState(false);
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [loader, setLoader] = useState(false);
  const [token, setToken] = useState();
  const [tableData, setTableData] = useState([]);
  const [isEditing, setEditing] = useState(false);
  const [ringFenceHeader,setRingFencHeader]=useState("")
  const [ringLoader,setRingLoader]=useState(false)

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    handleEditChange(props.location.state.item);
    getRingFenseData(token)
  }, []);

  const handleEditChange = (data) => {
    setID(data?.id)
    setCampaignId(data?.campaign_id);
    setNoOfUseTime(data?.num_times_use);
    setNoLimit(data?.multi_use == "Y" ? true : false);
    setCouponTitle(data?.coupon_title);
    setCouponDescription(data?.coupon_description);
    setCouponCode(data?.coupon_code);
    setDgcAmount(data?.dgc_amount)
    data?.campaign_for.map((item) => {
      if (item == "me") {
        setForMe(true);
      }
      if (item == "friend") {
        setForFriend(true);
      }
    });
    let campaignType = campaignTypeOptions?.filter(item => item?.value == data?.campaign_type);
    setCampaignType(campaignType[0])
    setAmount(
      data?.campaign_type == "upsize"
        ? data?.upsize_amount
        : data?.amount_discount
    );
    setPercenet(
      data?.campaign_type == "upsize"
        ? data?.upsize_percent
        : data?.percent_discount
    );
    data?.payment_methods?.map((item) => {
      if (item == "grab_otc") {
        setGrabPay(true);
      }
      if (item == "ocbc_paynow") {
        setOcbc(true);
      }
      if (item == "CC") {
        setCreditCard(true);
      }
      if(item == "paynowqr"){
        setPayNow(true)
      }
      if(item == "LifeSG"){
      setLifeSGPaymentMethod(true)
      }
      if(item == "shppay"){
        setShopeePay(true)
      }
      if(item == "spaylater"){
        setSPayLater(true)
      }
    });
    setShowPopUpMsg(data?.enabled == "Y" ? true : false);
    setModaleMessage(data?.modal_message ? data?.modal_message : "<p></p>");
    setPublishDate(moment(data?.start_date).format("YYYY-MM-DDTHH:mm"));
    data?.end_date == null
      ? setNeverEnding(true)
      : setUnPublishDate(moment(data?.end_date).format("YYYY-MM-DDTHH:mm"));

    setStatus(data?.status);
  };
  const getRingFenseData = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      "action": "read"
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    fetch(`${process.env.REACT_APP_FRX_API_URL}/2c2p-sftp`, requestOptions)
      .then(response => response.text())
      .then(result => {
        if(result){
          const inputData = JSON.parse(result)
          const rows = inputData.split('\n').filter(Boolean); // Split rows
      // Separate Header and Body
          const header = rows[0];
          setRingFencHeader(header)
          const body = rows.slice(1);
          const parsedData = parseApiResponse(body);
          setTableData(parsedData)
        }
      })
      .catch(error => console.log('error', error));

  };
  const handleSubmit = () => {
    //handle campaign for data
    let campaignForData = [];
    if (forMe) {
      campaignForData = [...campaignForData, "me"];
    }
    if (forFreind) {
      campaignForData.push("friend");
    }

    // handle payment method data
    let paymentMethodData = [];
    if (ocbc) {
      paymentMethodData.push("ocbc_paynow");
    }
    if (grabPay) {
      paymentMethodData.push("grab_otc");
    }
    if (creditCard) {
      paymentMethodData.push("CC");
    }
    // if(campaignType?.value == "upsize"){
      if(payNow){
        paymentMethodData.push("paynowqr");
      }
      if(lifeSGPaymentMethod){
        paymentMethodData.push("LifeSG");
      }
      if(shopeePay){
        paymentMethodData.push("shppay");
      }
      if(sPayLater){
        paymentMethodData.push("spaylater");
      }
    // }
    //handle validation
    if (!campaignID) {
      setErrorAlert(true);
      setErrorMessage("Please Enter Campaign ID");
      return;
    }
    if (!couponTitle) {
      setErrorAlert(true);
      setErrorMessage(`Please Enter ${campaignType?.value != "gwp" ? "Coupon Title": "GWP Name"}`);
      return;
    } else if (!couponDescription) {
      setErrorAlert(true);
      setErrorMessage(`Please Enter ${campaignType?.value != "gwp" ? "Coupon Description": "Item Name"}`);
      return;
    } else if (!couponCode) {
      setErrorAlert(true);
      setErrorMessage("Please Enter Coupon Code");
      return;
    }else if (!dgcAmount) {
      setErrorAlert(true);
      setErrorMessage("Please Enter dgc Amount");
      return;
    } else if (campaignForData.length < 1) {
      setErrorAlert(true);
      setErrorMessage("Please Select Campaign For");
      return;
    } else if (!percent && campaignType?.value != "gwp") {
      setErrorAlert(true);
      setErrorMessage("Please Enter Percent(%)");
      return;
    } else if (!amount && campaignType?.value != "gwp") {
      setErrorAlert(true);
      setErrorMessage("Please Enter Amount($)");
      return;
    } else if (paymentMethodData.length < 1) {
      setErrorAlert(true);
      setErrorMessage("Please Select Payment Method");
      return;
    } else if (publishDate == "Invalid date" || !publishDate) {
      setErrorMessage("Please select publish date");
      setErrorAlert(true);
      return;
    } else if (!neverEnding) {
      if (unPublishDate == "Invalid date" || !unPublishDate) {
        setErrorMessage("Please select unpublish date");
        setErrorAlert(true);
        return;
      }
    }
    if(publishDate > unPublishDate){
      setErrorMessage("Unpublish date should be after the publish date");
      setErrorAlert(true);
      return;
    }
    if (showPopUpMsg) {
      if (!checkTextInsideHtml(modalMessage)) {
        setErrorMessage("Please Enter Modale Message");
        setErrorAlert(true);
        return;
      }
    }

    var formdata = new FormData();
    formdata.append("id",ID);
    formdata.append("_method","PUT")
    formdata.append("campaign_id", campaignID);
    formdata.append("coupon_title", couponTitle);
    formdata.append("coupon_description", couponDescription);
    formdata.append("coupon_code", couponCode);
    formdata.append("dgc_amount", dgcAmount);
    formdata.append("start_date", publishDate);
    formdata.append("end_date", neverEnding ? null : unPublishDate);
    formdata.append("num_times_use", noOfUseTime);
    formdata.append("multi_use", noLimit ? "Y" : "N");
    formdata.append("campaign_for", campaignForData.toString());
    formdata.append("campaign_type", campaignType.value);
    if (campaignType.value == "upsize") {
      formdata.append("upsize_percent", percent);
      formdata.append("upsize_amount", amount);
    } else if(campaignType.value == "discount") {
      formdata.append("percent_discount", percent);
      formdata.append("amount_discount", amount);
    }
    formdata.append("payment_methods", paymentMethodData.toLocaleString());
    formdata.append("modal_message", modalMessage ? modalMessage : null);
    formdata.append("enabled", showPopUpMsg ? "Y" : "N");
    formdata.append("status", status);

    var myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/dgc-campaigns/update`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.message.includes("update")) {
          setSuccessAlert(true);
        } else {
          setSuccessAlert(false);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props?.history.push("/campaign-dgc");
          setSuccessAlert(false);
          setLoader(false);
        }}
        onCancel={() => {
          setSuccessAlert(false);
        }}
      >
        {props.location.state?.edit
          ? "Campaign DCG Updated Successfuly"
          : "Campaign DCG Created Successfully"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const checkTextInsideHtml = (htmlString) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/;
    const matchBookingInfo = regex.exec(htmlString);    
    if (matchBookingInfo && matchBookingInfo[1]) {
      return true;
    } else {
      const simpleStringRegex = /^[^<>\n]+$/;
      return simpleStringRegex.test(htmlString);
    }
  };
  const handleInputChange = (index, key, value) => {
    const updatedData = [...tableData];
    updatedData[index][key] = value;
    setTableData(updatedData);
  };
 
 
  const handleAddRow = () => {
    setEditing(true);
    setTableData([...tableData, { recordType: '', recordNo: '', merchantID: '', promoCode: '', promoDesc: '', cardType: '', binList: '', allowMasterpass: '', ippMode: '', ippProductCodeType: '', ippProductCodeList: '', limitByTransactionCount: '', maxAuthorisedTransaction: '', limitPerCard: '', maxTransactionPerCard: '' }]);
  };
 
 
  const handleSaveClick = () => {
    setEditing(false);
    setRingLoader(true)
    const formattedData = tableData.map((rowData) => {
      const { recordType, recordNo, merchantID, promoCode, promoDesc, cardType, binList, allowMasterpass, ippMode, ippProductCodeType, ippProductCodeList, limitByTransactionCount, maxAuthorisedTransaction, limitPerCard, maxTransactionPerCard } = rowData;
      return `${recordType}|${recordNo}|${merchantID}|${promoCode}|${promoDesc}|${cardType}|${binList}|${allowMasterpass}|${ippMode}|${ippProductCodeType}|${ippProductCodeList}|${limitByTransactionCount}|${maxAuthorisedTransaction}|${limitPerCard}|${maxTransactionPerCard}`;
    }).join('\n');

    let headerArray = ringFenceHeader?.split('|')
    headerArray[headerArray?.length-1] = tableData?.length
    let header= headerArray?.join('|')

    let finalResult=`${header}\n${formattedData}`
    if(finalResult){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "action": "write",
        "body": finalResult
      });
  
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      
      fetch(`${process.env.REACT_APP_FRX_API_URL}/2c2p-sftp`, requestOptions)
        .then(response => response.text())
        .then(result => {
         setRingLoader(false)
        })
        .catch(error => {
          console.log('error', error)
          setRingLoader(false)
      });
    }
  };
 
  const parseApiResponse = (input) => {
    const data = input?.map((row) => {
      const [recordType, recordNo, merchantID, promoCode, promoDesc, cardType, binList, allowMasterpass, ippMode, ippProductCodeType, ippProductCodeList, limitByTransactionCount, maxAuthorisedTransaction, limitPerCard, maxTransactionPerCard] = row.split('|');
      return {
        recordType, recordNo, merchantID, promoCode, promoDesc, cardType, binList, allowMasterpass, ippMode, ippProductCodeType, ippProductCodeList, limitByTransactionCount, maxAuthorisedTransaction, limitPerCard, maxTransactionPerCard,
      };
    });
    return data;
  };

  const handleEditClick = () => {
    setEditing(!isEditing);
  };

  const handleRemoveRow = (index) => {
    const updatedData = [...tableData];
    updatedData.splice(index, 1);
    setTableData(updatedData);
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Edit Campaigns DGC" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                      <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Campaign Type</Label>
                              <Select
                                isSearchable={false}
                                onChange={(e) => {
                                  setCampaignType(e);
                                }}
                                options={campaignTypeOptions}
                                placeholder={
                                  campaignType?.label
                                }
                                defaultValue={campaignType}
                                required
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4}>
                            <Label>Campaign ID</Label>
                            <input
                              onChange={(e) => {
                                setCampaignId(e.target.value);
                              }}
                              className="form-control"
                              type="text"
                              id="campaign_id_input"
                              value={campaignID}
                              min={1}
                            />
                          </Col>
                          <Col md={1}></Col>
                          <Col lg={4}>
                            <Label>No. of time use</Label>
                            <input
                              // disabled={noLimit}
                              onChange={(e) => {
                                setNoOfUseTime(e.target.value);
                              }}
                              className="form-control"
                              type="number"
                              id="Np_Of_Use_id_input"
                              defaultValue={noOfUseTime}
                              min={1}
                            />
                          </Col>
                          {/* <Col style={{ paddingTop: 35, paddingLeft: 20 }}>
                            <div className="form-check form-switch ">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="checkbox_1"
                                checked={noLimit}
                                onChange={() => {
                                  setNoLimit(!noLimit);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="checkbox_1"
                              >
                                No Limit
                              </label>
                            </div>
                          </Col> */}
                        </Row>
                        <Row className="mt-3">
                          <Col lg={4} md={6} sm={6}>
                            <Label>{campaignType?.value != "gwp" ? "Coupon Title" : "GWP Name"}</Label>
                            <input
                              onChange={(e) => {
                                setCouponTitle(e.target.value);
                              }}
                              className="form-control"
                              type="text"
                              id="campaign_id_input"
                              value={couponTitle}
                              min={1}
                            />
                          </Col>
                          <Col md={1}></Col>
                          <Col lg={4}>
                            <Label>{campaignType?.value != "gwp" ? "Coupon Description" : "Item Name"}</Label>
                            <input
                              onChange={(e) => {
                                setCouponDescription(e.target.value);
                              }}
                              className="form-control"
                              type="text"
                              id="campaign_id_input"
                              value={couponDescription}
                              min={1}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col md={4}>
                            <Label>Coupon Code</Label>
                            <input
                              onChange={(e) => {
                                setCouponCode(e.target.value);
                                console.log("onChange is called---->1122")
                              }}
                              className="form-control"
                              type="text"
                              id="coupon_code_input"
                              value={couponCode}
                            />
                          </Col>
                          <Col md={1}></Col>
                          <Col md={4}>
                            <Label>DGC Amount</Label>
                            <input
                              onChange={(e) => {
                                setDgcAmount(e.target.value);
                              }}
                              className="form-control"
                              type="number"
                              id="campaign_id_input"
                              defaultValue={dgcAmount}
                              min={1}
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row></Row>
                        <Row>
                          <Row className="mt-3">
                            <Col md={12}>
                              <Label>Campaign For</Label>
                            </Col>
                            <Col md={1} style={{ marginTop: "auto" }}>
                              <div style={{ margin: "0 0 15px 0" }}>
                                <input
                                  id={1}
                                  type="checkbox"
                                  onClick={(e) => {
                                    setForMe(!forMe);
                                  }}
                                  checked={forMe}
                                />
                                <label style={{ paddingLeft: "10px" }}>
                                  Me
                                </label>
                              </div>
                            </Col>
                            <Col md={1} style={{ marginTop: "auto" }}>
                              <div style={{ margin: "0 0 15px 0" }}>
                                <input
                                  id={1}
                                  type="checkbox"
                                  onClick={(e) => {
                                    setForFriend(!forFreind);
                                  }}
                                  checked={forFreind}
                                />
                                <label style={{ paddingLeft: "10px" }}>
                                  Friend
                                </label>
                              </div>
                            </Col>
                          </Row>
                        </Row>

                        {campaignType?.value != "gwp" && <Row className="mt-3">
                          <Col lg={4} md={6} sm={6}>
                            <Label>
                              {campaignType?.value == "upsize"
                                ? "Upsize Percent(%)"
                                : "Discount Percent(%)"}{" "}
                            </Label>
                            <input
                              onChange={(e) => {
                                setPercenet(e.target.value);
                              }}
                              className="form-control"
                              type="number"
                              id="campaign_id_input"
                              defaultValue={percent}
                              min={1}
                            />
                          </Col>
                          <Col md={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <Label>
                              {campaignType?.value == "upsize"
                                ? "Upsize Amount($)"
                                : "Discount Amount($)"}
                            </Label>
                            <input
                              onChange={(e) => {
                                setAmount(e.target.value);
                              }}
                              className="form-control"
                              type="number"
                              id="campaign_id_input"
                              defaultValue={amount}
                              min={1}
                            />
                          </Col>
                        </Row>}
                        <Row className="mt-3">
                          <Col md={12}>
                            <Label>Payment Method</Label>
                          </Col>
                          <div style={{display:"flex"}}>                            
                           <div style={{ margin: "0 35px 15px 0" }}>
                              <input
                                id={1}
                                type="checkbox"
                                onClick={(e) => {
                                  setOcbc(!ocbc);
                                }}
                                  checked={ocbc}
                              />
                              <label style={{ paddingLeft: "10px" }}>
                                OCBC
                              </label>
                            </div>
                            <div style={{ margin: "0 35px 15px 0" }}>
                              <input
                                id={1}
                                type="checkbox"
                                onClick={(e) => {
                                  setGrabPay(!grabPay);
                                }}
                                checked={grabPay}
                              />
                              <label style={{ paddingLeft: "10px" }}>
                                GrabPay
                              </label>
                            </div>
                            <div style={{ margin: "0 35px 15px 0" }}>
                              <input
                                id={1}
                                type="checkbox"
                                onClick={(e) => {
                                  setCreditCard(!creditCard);
                                }}
                                checked={creditCard}
                              />
                              <label style={{ paddingLeft: "10px" }}>
                                CreditCard
                              </label>
                            </div>
                            {/* {campaignType?.value == "upsize"&& */}
                            <div style={{ margin: "0 35px 15px 0" }}>
                              <input
                                id={1}
                                type="checkbox"
                                onClick={(e) => {
                                  setPayNow(!payNow);
                                }}
                                checked={payNow}
                              />
                              <label style={{ paddingLeft: "10px" }}>
                               PayNow
                              </label>
                            </div>
                            <div style={{ margin: "0 35px 15px 0" }}>
                              <input
                                id={1}
                                type="checkbox"
                                onClick={(e) => {
                                  setLifeSGPaymentMethod(!lifeSGPaymentMethod);
                                }}
                                checked={lifeSGPaymentMethod}
                              />
                              <label style={{ paddingLeft: "10px" }}>
                               LifeSG
                              </label>
                            </div>
                            <div style={{ margin: "0 35px 15px 0" }}>
                              <input
                                id={1}
                                type="checkbox"
                                onClick={(e) => {
                                  setShopeePay(!shopeePay);
                                }}
                                checked={shopeePay}
                              />
                              <label style={{ paddingLeft: "10px" }}>
                               ShopeePay
                              </label>
                            </div>
                            <div style={{ margin: "0 0 15px 0" }}>
                              <input
                                id={1}
                                type="checkbox"
                                onClick={(e) => {
                                  setSPayLater(!sPayLater);
                                }}
                                checked={sPayLater}
                              />
                              <label style={{ paddingLeft: "10px" }}>
                               SPayLater
                              </label>
                            </div>
                            {/* } */}
                            </div>
                          {/* <Col md={4}></Col> */}
                          <Row>
                            <Col md={3} className="">
                              <div className="form-check form-switch text-right">
                                <input
                                  type="checkbox"
                                  className="form-check-input checkbox"
                                  id="checkbox_1"
                                  checked={showPopUpMsg}
                                  onClick={() => {
                                    setShowPopUpMsg(!showPopUpMsg);
                                    // setModaleMessage("<p></p>")
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="checkbox_1"
                                >
                                  Add Popup Message
                                </label>
                              </div>
                            </Col>
                          </Row>
                        </Row>
                        {showPopUpMsg && (
                          <Row className="mt-3">
                            <Col md={6}>
                              <Label>Modal Message</Label>
                              <ReactQuill
                                modules={{
                                  toolbar: [
                                    ["bold", "italic", "underline"],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    ["link", { color: [] }],
                                    ["clean"],
                                  ],
                                }}
                                theme="snow"
                                value={modalMessage}
                                onChange={(e) => {
                                  setModaleMessage(e);
                                }}
                              />
                            </Col>
                          </Row>
                        )}
                      </CardBody>
                    </Card>

                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Publish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={publishDate}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Unpublish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setUnPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={unPublishDate}
                                  disabled={neverEnding}
                                />
                              </div>
                            </div>
                          </Col>
                          {/* <Col style={{ paddingTop: 35 }}>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="checkbox_1"
                                checked={neverEnding}
                                onChange={() => {
                                  setNeverEnding(!neverEnding);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="checkbox_1"
                              >
                                Never-ending
                              </label>
                            </div>
                          </Col> */}
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <h3 style={{fontSize:18,fontWeight:600}}>Ring Fencing via 2c2p</h3>
                      <div className="table-responsive">
                          <Table responsive striped className="table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>recordType</th>
                                <th>recordNo</th>
                                <th>merchantID</th>
                                <th>promoCode</th>
                                <th>promoDesc</th>
                                <th>cardType</th>
                                <th>binList</th>
                                <th>allowMasterpass</th>
                                <th>ippMode</th>
                                <th>ippProductCodeType</th>
                                <th>ippProductCodeList</th>
                                <th>limitByTransactionCount</th>
                                <th>maxAuthorisedTransaction</th>
                                <th>limitPerCard</th>
                                <th>maxTransactionPerCard</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tableData?.map((rowData, index) => (
                                <tr key={index}>
                                  {Object.values(rowData).map((value, colIndex) => (
                                    <td key={colIndex}>
                                      {isEditing ? (
                                        <input
                                        style={{    width: 130,
                                          height: 30}}
                                          type="text"
                                          className="form-control"
                                          defaultValue={value}
                                          onChange={(e) => handleInputChange(index, Object.keys(rowData)[colIndex], e.target.value)}
                                        />
                                      ) : (
                                        <span>{value}</span>
                                      )}
                                    </td>
                                  ))}
                                  {isEditing && (
                                  <td>
                                    <Button onClick={() => handleRemoveRow(index)}>Delete</Button>
                                  </td>)}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                       <Button color="primary" disabled={ringLoader} onClick={handleSaveClick} style={{ marginTop: '10px', marginRight:10,width:65 }}>
                      {ringLoader ? (
                          <CircularProgress
                            size={15}
                            value={100}
                            color={"white"}
                          />
                        ) : (
                          "Save"
                        )}
                      </Button>
                      <Button color="danger" onClick={handleEditClick} style={{ marginTop: '10px', marginRight:10 }}>
                        Edit
                      </Button>
                      <Button color="dark" onClick={handleAddRow} style={{ marginTop: '10px' }}>
                        Add
                      </Button>
                  </div>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                // value={selectedStatus}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/campaign-dgc");
                        }}
                        color="danger"
                        type="submit"
                      >
                        Cancel
                      </Button>
                      <button
                        disabled={loader}
                        style={{
                          color: "#ffffff",
                          width: "80px",
                          marginLeft: "10px",
                        }}
                        className={"btn btn-success"}
                        onClick={() => {
                          handleSubmit();
                        }}
                        color="success"
                        type="submit"
                      >
                        {loader ? (
                          <CircularProgress
                            size={15}
                            value={100}
                            color={"white"}
                          />
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditCampaignDgc;
